import {
  List,
  Datagrid,
  TextField,
  RichTextField,
  UrlField,
  SearchInput,
  TextInput,
  DeleteWithConfirmButton,
  Edit,
  SimpleForm,
  Create,
  Show,
  SimpleShowLayout,
} from 'react-admin'
// import { CustomRichTextInput } from '../components/CustomRichTextInput'

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const PartnerList = ({ isEdit, isDelete }) => (
  <List filters={[<SearchInput source="search" alwaysOn />, <TextInput source="search" />]}>
    <Datagrid bulkActionButtons={false} rowClick={isEdit ? 'edit' : 'show'}>
      <TextField source="title" />
      <UrlField source="logoUrl" />
      <UrlField source="websiteUrl" />
      <UrlField source="docsUrl" />
      <UrlField source="communityUrl" />
      <UrlField source="twitterUrl" />
      {isDelete && (
        <DeleteWithConfirmButton confirmContent="This action could not be reverted. Are you sure?" />
      )}
    </Datagrid>
  </List>
)

export const PartnerEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="title" />
      <TextInput source="description" multiline rows={2} fullWidth />
      <TextInput source="logoUrl" type="url" />
      <TextInput source="websiteUrl" type="url" />
      <TextInput source="docsUrl" type="url" />
      <TextInput source="communityUrl" type="url" />
      <TextInput source="twitterUrl" type="url" />
    </SimpleForm>
  </Edit>
)

export const PartnerCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="title" required />
      <TextInput source="description" multiline rows={2} fullWidth required />
      <TextInput source="logoUrl" type="url"  />
      <TextInput source="websiteUrl" type="url"  />
      <TextInput source="docsUrl" type="url"  />
      <TextInput source="communityUrl" type="url"  />
      <TextInput source="twitterUrl" type="url"  />
    </SimpleForm>
  </Create>
)

export const PartnerShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="title" />
      <RichTextField source="description" />
      <UrlField source="logoUrl" />
      <UrlField source="websiteUrl" />
      <UrlField source="docsUrl" />
      <UrlField source="communityUrl" />
      <UrlField source="twitterUrl" />
    </SimpleShowLayout>
  </Show>
)
